export const blockIconsSocialEmojiEmotions = (
	<span className='material-symbols-outlined'>emoji_emotions</span>
);
